import { render } from "./PrivacyPolicy.vue?vue&type=template&id=18fbe55b"
import script from "./PrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicy.vue?vue&type=script&lang=js"
script.render = render

export default script